import { StateService } from "@uirouter/angularjs";
import {EditCustomFieldNameModel} from "../../models/tasks/EditCustomFieldNameModel";
import {NotificationService} from "../../services/NotificationService";

export class EditCustomFieldNameCtrl {
    $scope:any;
    gridOptions:any;
    displayGridOptions:any;
    handheldDisplayGridOptions:any;
    saved:boolean = false;
    stateChangedListener:any;
    public static $inject = ['$scope','$window','$location','$state','EditCustomFieldNameModel','NotificationService','uiGridConstants'];
    constructor($scope:any,
                public $window:ng.IWindowService,
                public $location:ng.ILocationService,
                public stateService:StateService,
                public model:EditCustomFieldNameModel,
                public notifyService:NotificationService,
                public uiGridConstants:any) {
        this.$scope = $scope;
        $scope.vm = this;
        this.saved = false;
        this.stateChangedListener = $scope.$on('$stateChangeStart',(event:any, toState:any, toParams:any)=> {
          if (!this.saved) {
            event.preventDefault();
            var leave = $window.confirm("Are you sure you want to leave this screen without saving your work?");
            if(leave){
              this.saved = true;
              //this.$scope.$off(this.stateChangedListener);
              this.stateService.go(toState,toParams);
              //$location.url($location.url(next).hash());
              //$rootScope.$apply();
            }
            else{
            }
          }
          else{
            //this.$scope.$off(this.stateChangedListener);
          }
        });
        this.displayGridOptions = {
            multiSelect:false,
            enableSorting:false,
            columnDefs:[{field:'name',name:'Name'},{field:'value',name:'Value'},{field:'display',name:'Display'}],
            data:[],
            onRegisterApi:function(gridApi:any) {
                gridApi.selection.on.rowSelectionChanged($scope,function(row:any) {
                    var entity = row.entity;
                    //alert("row selection changed. entity.name="+entity.name+". is selected="+row.isSelected);
                    if (row.isSelected) {
                        $scope.vm.model.selectedCfn = entity;
                    }
                    else
                        $scope.vm.model.selectedCfn = null;
                });
            }
        };
        this.handheldDisplayGridOptions = {
            multiSelect:false,
            sortInfo: {fields:['handheldDisplayIndex'], directions:['asc']},
            columnDefs:[{field:'name',name:'Name'},{field:'handheldValue',name:'Handheld Value'},{field:'handheldDisplay',name:'Handheld Display'}],
            data:[],
            onRegisterApi:function(gridApi:any) {
                gridApi.selection.on.rowSelectionChanged($scope,function(row:any) {
                    var entity = row.entity;
                    //alert("row selection changed. entity.name="+entity.name+". is selected="+row.isSelected);
                    if (row.isSelected) {
                        $scope.vm.model.selectedHandheldCfn = entity;
                    }
                    else
                        $scope.vm.model.selectedHandheldCfn = null;
                });
            }
        };
        this.model.loadData().then(()=>{
            this.displayGridOptions.data = this.model.customFieldNames;
            console.log("this.model="+this.model.customFieldNames[0].displayIndex);
            this.handheldDisplayGridOptions.data = this.model.hhCustomFieldNames;
        })
        .catch((exc)=>{
            this.notifyService.notify("Error getting custom field names");
        });
    }
    handleLeaving(event:any, next:any, current:any):void{
      if (!this.saved) {
        event.preventDefault();
        var leave = this.$window.confirm("Are you sure you want to leave this screen without saving your work?");
        if(leave){
          this.$scope.$off(this.handleLeaving);
          this.stateService.go(next.name);
          //$location.url($location.url(next).hash());
          //$rootScope.$apply();
        }
        else{
        }
      }
      else{
        this.$scope.$off(this.handleLeaving);
      }
    }
    moveUp(){
        this.model.moveUp();
        this.displayGridOptions.data = this.model.customFieldNames;
    }
    moveDown(){
        this.model.moveDown();
        this.displayGridOptions.data = this.model.customFieldNames;
    }
    hhMoveUp(){
        this.model.hhMoveUp();
        this.handheldDisplayGridOptions.data = this.model.hhCustomFieldNames;
    }
    hhMoveDown(){
        this.model.hhMoveDown();
        this.handheldDisplayGridOptions.data = this.model.hhCustomFieldNames;
    }
    save(){
        this.saved = true;
        this.model.save().then(()=>{
            this.notifyService.notify("Custom Field Name changes have been saved. You will need to log back in before changes show up.");
        })
        .catch((exc)=>{
            this.notifyService.notifyError("Error saving Custom Fields:"+exc);
        });
    }
}
